import { render, staticRenderFns } from "./Forbehold.vue?vue&type=template&id=3cdef978"
import script from "./Forbehold.vue?vue&type=script&lang=js"
export * from "./Forbehold.vue?vue&type=script&lang=js"
import style0 from "./Forbehold.vue?vue&type=style&index=0&id=3cdef978&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports